import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.ts'), 'store/index.ts')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/band_dashboard.js'), 'band_dashboard.js')
  resolveStoreModules(require('../store/band_signup.ts'), 'band_signup.ts')
  resolveStoreModules(require('../store/cart.js'), 'cart.js')
  resolveStoreModules(require('../store/csrf.ts'), 'csrf.ts')
  resolveStoreModules(require('../store/draft.js'), 'draft.js')
  resolveStoreModules(require('../store/influencer_dashboard.js'), 'influencer_dashboard.js')
  resolveStoreModules(require('../store/influencers.ts'), 'influencers.ts')
  resolveStoreModules(require('../store/login.ts'), 'login.ts')
  resolveStoreModules(require('../store/notification.ts'), 'notification.ts')
  resolveStoreModules(require('../store/payin.js'), 'payin.js')
  resolveStoreModules(require('../store/routing.ts'), 'routing.ts')
  resolveStoreModules(require('../store/snackbar.ts'), 'snackbar.ts')
  resolveStoreModules(require('../store/tag.ts'), 'tag.ts')
  resolveStoreModules(require('../store/user.ts'), 'user.ts')
  resolveStoreModules(require('../store/draft/pricing.js'), 'draft/pricing.js')
  resolveStoreModules(require('../store/draft/promo.js'), 'draft/promo.js')
  resolveStoreModules(require('../store/draft/track.js'), 'draft/track.js')
  resolveStoreModules(require('../store/influencer_dashboard/inspector.js'), 'influencer_dashboard/inspector.js')
  resolveStoreModules(require('../store/influencers/recommendation.ts'), 'influencers/recommendation.ts')
  resolveStoreModules(require('../store/misc/draft.js'), 'misc/draft.js')
  resolveStoreModules(require('../store/misc/intercom.js'), 'misc/intercom.js')
  resolveStoreModules(require('../store/misc/menu.js'), 'misc/menu.js')
  resolveStoreModules(require('../store/misc/sendtrack.js'), 'misc/sendtrack.js')
  resolveStoreModules(require('../store/payin/billing_infos.js'), 'payin/billing_infos.js')
  resolveStoreModules(require('../store/payin/packs.js'), 'payin/packs.js')
  resolveStoreModules(require('../store/payin/payment_method.js'), 'payin/payment_method.js')
  resolveStoreModules(require('../store/user/agency.ts'), 'user/agency.ts')
  resolveStoreModules(require('../store/user/band_set.ts'), 'user/band_set.ts')
  resolveStoreModules(require('../store/user/band.js'), 'user/band.js')
  resolveStoreModules(require('../store/user/favorites.ts'), 'user/favorites.ts')
  resolveStoreModules(require('../store/user/influencer.js'), 'user/influencer.js')
  resolveStoreModules(require('../store/user/sudo.js'), 'user/sudo.js')
  resolveStoreModules(require('../store/misc/band/signup.js'), 'misc/band/signup.js')
  resolveStoreModules(require('../store/misc/sendtrack/filters.ts'), 'misc/sendtrack/filters.ts')
  resolveStoreModules(require('../store/payin/billing_infos/legal_data.js'), 'payin/billing_infos/legal_data.js')
  resolveStoreModules(require('../store/payin/billing_infos/natural_user.js'), 'payin/billing_infos/natural_user.js')
  resolveStoreModules(require('../store/payin/payment_method/mangopay.js'), 'payin/payment_method/mangopay.js')
  resolveStoreModules(require('../store/payin/payment_method/paypal.js'), 'payin/payment_method/paypal.js')
  resolveStoreModules(require('../store/user/influencer/tags.js'), 'user/influencer/tags.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
